import {Utilities} from '@shared/utilities/utilities.model';

export class MovementsDetailTyreModel {

    cod_dot: string;
    cod_manufacturer: string;
    cod_tyre_alert_reason: string;
    cod_tyre_transfer_status: string;
    custom_data: string;
    id_transfer_tyre: number;
    txt_label_efficiency: string;
    txt_label_grip: string;
    txt_label_noisiness: string;
    txt_load_rating: string;
    txt_manufacturer: string;
    txt_ms: string;
    txt_notes: string;
    txt_pattern: string;
    txt_rof: string;
    txt_season: string;
    txt_speed_rating: string;
    txt_tpm: string;
    txt_tread_height: string;
    txt_tread_width: string;
    val_label_noisiness_decibel: number;
    val_pressure: number;
    val_ratio: string;
    val_wheel_diameter: string;

    constructor(model?: any | MovementsDetailTyreModel) {
        if (!Utilities.isVoid(model)) {
            this.cod_dot = model.cod_dot;
            this.cod_manufacturer = model.cod_manufacturer;
            this.cod_tyre_alert_reason = model.cod_tyre_alert_reason;
            this.cod_tyre_transfer_status = model.cod_tyre_transfer_status;
            this.custom_data = model.custom_data;
            this.id_transfer_tyre = model.id_transfer_tyre;
            this.txt_label_efficiency = model.txt_label_efficiency;
            this.txt_label_grip = model.txt_label_grip;
            this.txt_label_noisiness = model.txt_label_noisiness;
            this.txt_load_rating = model.txt_load_rating;
            this.txt_manufacturer = model.txt_manufacturer;
            this.txt_manufacturer = model.txt_manufacturer;
            this.txt_ms = model.txt_ms;
            this.txt_notes = model.txt_notes;
            this.txt_pattern = model.txt_pattern;
            this.txt_rof = model.txt_rof;
            this.txt_season = model.txt_season;
            this.txt_speed_rating = model.txt_speed_rating;
            this.txt_tpm = model.txt_tpm;
            this.txt_tread_height = model.txt_tread_height;
            this.txt_tread_width = model.txt_tread_width;
            this.val_label_noisiness_decibel = model.val_label_noisiness_decibel;
            this.val_pressure = model.val_pressure;
            this.val_ratio = model.val_ratio;
            this.val_wheel_diameter = model.val_wheel_diameter;
        }
    }

}
